import { TipBox, TipWrap, useTip } from "./Tip";

/** Gauge radial: satu proporsi, angka di tengah. Dipakai untuk komposisi tone
 *  supaya porsinya terbaca sebagai persen, bukan sebagai potongan lingkaran. */
export function Gauge({ value, total, color, label, size = 92 }: {
  value: number; total: number; color: string; label: string; size?: number;
}) {
  const { wrapRef, tip, tipUntuk } = useTip();
  const pct = total ? (value / total) * 100 : 0;
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const on = (pct / 100) * c;
  const nf = (x: number) => Intl.NumberFormat("id-ID").format(x ?? 0);
  const isi = {
    judul: label,
    baris: [
      { warna: color, label: "dari total", nilai: `${nf(value)} / ${nf(total)}` },
      { label: "porsi", nilai: `${pct.toFixed(1).replace(".", ",")}%` },
    ],
  };
  return (
    <TipWrap wrapRef={wrapRef}>
      <div>
        <div style={{ position: "relative", width: size, height: size, margin: "0 auto", cursor: "default" }} {...tipUntuk(isi)}>
          <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }} role="img" aria-label={`${label} ${pct.toFixed(1)}% (${nf(value)} dari ${nf(total)})`}>
            <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--mark-grid)" strokeWidth={9} />
            <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={9}
              strokeLinecap="round" strokeDasharray={`${on} ${c - on}`} />
          </svg>
          <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center" }}>
            <span className="avio-gauge__num">{pct.toFixed(1).replace(".", ",")}%</span>
          </div>
        </div>
        <div className="avio-gauge__cap" style={{ marginTop: "var(--space-4)" }}>
          <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: 2, background: color, marginRight: 6 }} />
          {label}
        </div>
        <div className="avio-sub">{nf(value)}</div>
      </div>
      <TipBox tip={tip} />
    </TipWrap>
  );
}
